import { useNavigate } from "react-router-dom";

export const useSmartBack = (fallback = "/dashboard") => {
  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };

  return goBack;
};
